import {
  patchState,
  signalStoreFeature,
  withMethods,
  withState,
} from '@ngrx/signals';

const initialState: {
  isDragging: boolean;
  cursor: string;
} = {
  isDragging: false,
  cursor: '',
};

export function withDragAndDropInit() {
  return signalStoreFeature(
    withState(initialState),
    withMethods((store) => {
      const handleMouseDown = (event: MouseEvent) => {
        // to prevent the browser default behavior:
        // if there's a text selection, it will be considered first to be dragged
        event.stopPropagation();
        event.preventDefault();
        patchState(store, (state) => ({
          ...state,
          isDragging: true,
        }));
        setTimeout(() => {
          if (!store.isDragging()) return;
          changeCursorStyle();
        }, 200);
      };

      const changeCursorStyle = () => {
        patchState(store, (state) => ({
          ...state,
          cursor: 'grab',
        }));
      };

      const handleMouseUp = () => {
        patchState(store, () => initialState);
      };

      const handleMouseLeave = (): boolean => {
        if (!store.isDragging()) return false;
        patchState(store, () => initialState);
        return true;
      };

      return {
        initDragAndDrop(event: MouseEvent): boolean {
          if (event.type === 'mousedown') {
            handleMouseDown(event);
          } else if (event.type === 'mouseup') {
            handleMouseUp();
          } else if (event.type === 'mouseleave') {
            return handleMouseLeave();
          }
          return false;
        },
      };
    }),
  );
}
